import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, ChevronRight, Users, User } from "lucide-react";

const FoundationsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#070B14] text-white flex flex-col items-center justify-center px-6 relative overflow-hidden">
      <div className="absolute inset-0 z-0">
        <div className="absolute top-0 left-1/2 w-[800px] h-[600px] bg-blue-600/6 rounded-full blur-[150px] -translate-x-1/2 -translate-y-1/2" />
      </div>

      <div className="relative z-10 w-full max-w-5xl mx-auto text-center">
        <button
          onClick={() => navigate("/")}
          className="flex items-center gap-2 text-white/50 hover:text-white/80 transition-colors text-sm mb-10 mx-auto"
          data-testid="foundations-back"
        >
          <ArrowLeft className="w-4 h-4" /> Back
        </button>

        <div className="flex items-center justify-center gap-3 mb-6">
          <img src="/paladin-logo.jpeg" alt="Paladin" className="w-10 h-10 rounded-lg object-contain" />
          <span className="font-bold text-sm tracking-wider text-white/60">PALADIN</span>
        </div>

        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <h1 className="text-4xl sm:text-5xl font-black tracking-tight mb-4">
            <span className="text-blue-400">FOUNDATIONS</span>
          </h1>
          <p className="text-white/50 text-sm max-w-lg mx-auto mb-12">
            Build the base that everything else is built on. Who is this for?
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          <motion.button
            initial={{ opacity: 0, x: -40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            onClick={() => navigate("/foundations/youth")}
            className="group relative overflow-hidden rounded-2xl border border-blue-500/30 bg-gradient-to-b from-blue-500/10 to-transparent p-8 md:p-10 text-left hover:border-blue-400/60 hover:shadow-2xl hover:shadow-blue-500/20 transition-all duration-500 cursor-pointer"
            data-testid="foundations-youth"
          >
            <Users className="w-10 h-10 text-blue-400 mb-5" />
            <h2 className="text-2xl md:text-3xl font-black tracking-tight mb-3">YOUTH<br />ATHLETES</h2>
            <p className="text-white/70 text-sm leading-relaxed mb-6">
              Ages 10-18. Build a strong athletic foundation while developing coordination, strength, and confidence.
            </p>
            <div className="flex items-center gap-2 text-blue-400 font-semibold text-sm group-hover:gap-3 transition-all">
              <span>Learn More</span>
              <ChevronRight className="w-4 h-4" />
            </div>
          </motion.button>

          <motion.button
            initial={{ opacity: 0, x: 40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            onClick={() => navigate("/foundations/adults")}
            className="group relative overflow-hidden rounded-2xl border border-blue-500/30 bg-gradient-to-b from-blue-500/10 to-transparent p-8 md:p-10 text-left hover:border-blue-400/60 hover:shadow-2xl hover:shadow-blue-500/20 transition-all duration-500 cursor-pointer"
            data-testid="foundations-adult"
          >
            <User className="w-10 h-10 text-blue-400 mb-5" />
            <h2 className="text-2xl md:text-3xl font-black tracking-tight mb-3">ADULTS</h2>
            <p className="text-white/70 text-sm leading-relaxed mb-6">
              New to lifting or coming back after time off. Build strength, improve mobility, and feel better every day.
            </p>
            <div className="flex items-center gap-2 text-blue-400 font-semibold text-sm group-hover:gap-3 transition-all">
              <span>Learn More</span>
              <ChevronRight className="w-4 h-4" />
            </div>
          </motion.button>
        </div>

        <p className="mt-12 text-white/40 text-xs">
          Already a member?{" "}
          <button onClick={() => navigate("/login")} className="text-white/70 hover:text-white underline underline-offset-2 transition-colors">
            Sign in
          </button>
        </p>
      </div>
    </div>
  );
};

export default FoundationsPage;
